import Description from './src/description'
export default Description


// WEBPACK FOOTER //
// ./src/components/description/index.js